@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@gridFontSize: 14px;

.alert-row {
  width: 100%;
  display: flex;
  border: 1px solid @order-alerts-modal--border-color;
  border-top: none;
}

.alerts-grid-buttons {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
}

.alerts-grid-header {
  background-color: @order-alerts-modal--background-color;
  border: 1px solid @order-alerts-modal--border-color;
  border-radius: 2px 2px 0 0;
  display: flex;
  font-weight: 500;
  > div {
    border-right: 1px solid @order-alerts-modal--border-color;
  }
  > div:last-child {
    border-right: 0;
  }
}

.alert-row,
.alerts-grid-header {
  > div {
    padding: 5px;
    font-size: @gridFontSize;
  }
  > div:first-child {
    padding: 5px 10px;
    align-self: center;
  }
  > div:nth-child(2) {
    width: 180px;
    align-self: center;
  }
  > div:last-child {
    max-width: 520px;
  }
}

.alert-rows-wrapper {
  max-height: 275px;
  overflow-y: auto;
}

.alerts-load-more {
  padding: 10px;
  display: flex;
  width: 100%;
}

.load-more-button {
  margin: 0 auto;
}

.loading-icon-wrap {
  height: 30px;
  width: 30px;
  margin: 0 auto;
}
.loading-icon {
  > svg {
    height: 100%;
  }
}

.alerts-error {
  background-color: @order-alerts-modal--error--background-color;
  border: 1px solid @order-alerts-modal--error--border-color;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  width: 500px;
  text-align: center;
  margin-top: 3px;
}
